import React from 'react';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Menu,
  MenuItem,
  Checkbox,
} from '@material-ui/core';
import { AddCircle, DragIndicator, MoreHoriz, RemoveCircle } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { TELEPHONY_DIRECTORY_EDIT } from '../../../../../constants/ServiceConstants';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_TELEPHONY,
} from '../../../../../constants/RoleConsts';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import CustomChip from '../../../../../shared/form-controls/custom-chip/Custom-Chip';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import { PARTIAL_CHECKBOX_GREEN } from '../../../../../utils/formUtils';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';

const DirectoryListTable = (props) => {
  const {
    telephonyDirectoriesList,
    page,
    rowsPerPage,
    handleCellMenuClick,
    selectedValue,
    handleClose,
    onClickRowViewDetails,
    onViewDetails,
    handleChangePage,
    handleChangeRowsPerPage,
    onOpenDrawer,
    onActiveDeActiveDirectories,
    onDeleteDirectories,
    permissions,
    setVisible,
    setTelephonyDirectoriesList,
    isAllSelected,
    setIsAllSelected,
    setActionMenuList,
    selectedCheckedTelephonyDirectoriesLength,
    telephonyDirectories,
    dragDisabled,
  } = props;

  const handleSelectAll = (event) => {
    let selectedTelephonyDirectoriesLis = [];
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    selectedTelephonyDirectoriesLis = telephonyDirectoriesList?.map((item) => {
      return {
        ...item,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedTelephonyDirectoriesLis?.some(
      (telephonyDirectories) => telephonyDirectories?.isActive,
    );
    const isInactive = selectedTelephonyDirectoriesLis?.some(
      (telephonyDirectories) => !telephonyDirectories.isActive,
    );

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }

    setTelephonyDirectoriesList([...selectedTelephonyDirectoriesLis]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (
      !event?.target?.checked &&
      !selectedTelephonyDirectoriesLis.some((item) => item?.isChecked)
    ) {
      setActionMenuList([]);
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let actionList = [];
    let index = telephonyDirectoriesList?.findIndex((item) => item.id === id);
    if (!telephonyDirectoriesList[index]?.isChecked) {
      telephonyDirectoriesList[index] = {
        ...telephonyDirectoriesList[index],
        isChecked: true,
      };
    } else {
      telephonyDirectoriesList[index].isChecked = !telephonyDirectoriesList[index]?.isChecked;
    }
    setTelephonyDirectoriesList([...telephonyDirectoriesList]);

    actionList = telephonyDirectoriesList
      ?.filter((directory) => directory?.isChecked)
      .map((status) => status?.isActive);

    const checkedItems = telephonyDirectoriesList?.filter((directory) => directory?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }

    const isAllSelected = telephonyDirectoriesList?.every((item) => item?.isChecked);
    setIsAllSelected(isAllSelected);
    setActionMenuList(actionListName);
  };

  return (
    <TableContainer>
      <Table className='list-table' aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
              <BulkActionCheckBox
                onChange={handleSelectAll}
                checked={isAllSelected || false}
                selectedLength={selectedCheckedTelephonyDirectoriesLength}
                totalLength={telephonyDirectories?.length}
                inputProps={{
                  'aria-label': 'select all telephone directories',
                }}
                className={PARTIAL_CHECKBOX_GREEN}
              />
            </TableCell>
            <TableCell className='w-40'>Name</TableCell>
            <TableCell className='w-20' align='right'>
              Number
            </TableCell>
            <TableCell className='w-30' align='center'>
              Status
            </TableCell>
            <TableCell align='right'></TableCell>
          </TableRow>
        </TableHead>

        <DragDropContext
          onDragEnd={(event) =>
            handleOnDragEnd(
              event,
              setVisible,
              telephonyDirectoriesList,
              setTelephonyDirectoriesList,
              false,
              page,
              rowsPerPage,
            )
          }
          isDropDisabled={dragDisabled}
        >
          <Droppable droppableId='services' isDropDisabled={dragDisabled}>
            {(provided) => (
              <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                {(rowsPerPage > 0
                  ? telephonyDirectoriesList.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage,
                    )
                  : telephonyDirectoriesList
                ).map((directoryKey, key) => (
                  <Draggable
                    key={directoryKey.id}
                    draggableId={directoryKey.id}
                    index={key}
                    isDragDisabled={dragDisabled}
                  >
                    {(provided) => (
                      <TableRow
                        key={key}
                        className='border-white pointer'
                        onClick={(e) => {
                          onClickRowViewDetails(directoryKey, e);
                        }}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <TableCell className='w-12'>
                          {!dragDisabled && (
                            <span style={{ marginRight: 1.5 }}>
                              <DragIndicator className='res-menu-accordion-drag ' />
                            </span>
                          )}
                          <Checkbox
                            onChange={(event) => handleCheckboxChange(directoryKey?.id)}
                            checked={directoryKey?.isChecked || false}
                            inputProps={{
                              'aria-label': `select directoryKey ${directoryKey?.id}`,
                            }}
                          />
                        </TableCell>
                        <TableCell className='w-40'>{directoryKey?.name}</TableCell>
                        <TableCell className='w-20' align='right'>
                          {directoryKey?.extensionNumber}
                        </TableCell>
                        <TableCell className='w-30' align='center'>
                          <CustomChip
                            label={directoryKey?.isActive ? 'Active' : 'Inactive'}
                            color={directoryKey?.isActive ? 'primary' : 'default'}
                          />
                        </TableCell>
                        <TableCell align='right'>
                          {permissions[RBAC_TYPE_SERVICES_TELEPHONY] ===
                            RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                            <Button
                              aria-controls='simple-menu'
                              aria-haspopup='true'
                              onClick={(e) => {
                                handleCellMenuClick(e, directoryKey);
                              }}
                              className='showpopupInner'
                            >
                              <MoreHoriz className='showpopupInner' />
                            </Button>
                          )}
                          <Menu
                            id={key}
                            disableRestoreFocus
                            MenuListProps={{ autoFocusItem: false }}
                            anchorEl={selectedValue?.anchorEl}
                            keepMounted
                            open={
                              Boolean(selectedValue.anchorEl) &&
                              selectedValue.id === directoryKey.id
                            }
                            onClose={handleClose}
                            className='shadow'
                          >
                            <MenuItem
                              className='pe-4'
                              onClick={(e) =>
                                onActiveDeActiveDirectories(
                                  e,
                                  selectedValue?.telephonyDirectories?.isActive,
                                )
                              }
                            >
                              {selectedValue?.telephonyDirectories?.isActive ? (
                                <>
                                  <RemoveCircle className='me-2 action-menu-icon' />
                                  Deactivate
                                </>
                              ) : (
                                <>
                                  <AddCircle className='me-2 action-menu-icon' />
                                  Activate
                                </>
                              )}
                            </MenuItem>
                            <MenuItem
                              className='pe-4'
                              onClick={(e) => onOpenDrawer(e, TELEPHONY_DIRECTORY_EDIT)}
                            >
                              <CreateIcon className='me-2 action-menu-icon' />
                              Edit
                            </MenuItem>
                            <MenuItem
                              className='pe-4'
                              onClick={(e) => onViewDetails(directoryKey, e)}
                            >
                              <VisibilityIcon className='me-2 action-menu-icon' />
                              View
                            </MenuItem>
                            <MenuItem className='pe-4' onClick={(e) => onDeleteDirectories(e)}>
                              <DeleteForeverIcon className='me-2 action-menu-icon' />
                              Delete
                            </MenuItem>
                          </Menu>
                        </TableCell>
                      </TableRow>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </TableBody>
            )}
          </Droppable>
        </DragDropContext>
        <TableFooter>
          <TableRow className='paginator'>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              count={telephonyDirectoriesList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default DirectoryListTable;
